import application_settings from '../applicationSettings';
import Event from './Event';

class GetAddress extends Event {
  eventName = "oms_getAddress";

  constructor() {
    super();
    this.add();
  }

  /**
   * @override
   *
   * Event Function for Get loyalty points
   *
   * @return void
   *
   */
  eventFunction(data) {
    let thisObj = this;
    let requestId = data.request_id ? data.request_id : "";
    let action = data.action ? data.action : "";
    let multiCallKey = data.multi_call_key ? data.multi_call_key : "address_list";
    let id = data.id ? data.id : "";
      
    data.endPoint = application_settings.endPoints.getAddress;
    data.method = 'POST';
    data.canUsePublicAuth = false;
    data.multi_call_key = multiCallKey;
    data.data = {
      id: id,
    };

    this.sendRequest(data, function (response) {
        if (response) {
            //format response data
            let data = thisObj.formatResponseData(response);

            //fire success event
            thisObj.onSuccessEvent(data, {
              action: action,
              request_id: requestId,
            });
        }
    });
    
  }
}

export default GetAddress;